class UserPersonnelInfo {
  constructor(personnelNumber, startDate, userId, organizationRoleId) {
    this.personnelNumber = personnelNumber;
    this.startDate = startDate;
    this.userId = userId;
    this.organizationRoleId = organizationRoleId;
  }
}
import Vue from 'vue';
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      userId: null,
      userPersonnelInfoId: null,
      searchTitle: '',
      disabelConfirm: false,
      addFlag: false,
      modalTitle: '',
      showAddEditModal: false,
      modalIcon: '',
      userPersonnelInfoManagmentInformationTableHeaders: [
        { text: 'ردیف', value: 'counter', align: 'center' },
        { text: 'تاریخ شروع', value: 'startDate', align: 'center' },
        { text: 'سمت', value: 'role', align: 'center' },
        { text: 'شماره پرسنلی', value: 'personnelNumber', align: 'center' },
        { text: 'تاریخ پایان', value: 'endDate', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
      tempUserStartDate: '',
      showUserStartDate: false,
    };
  },
  methods: {
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.modalTitle = 'افزودن اطلاعات شخصی';
        this.modalIcon = 'mdi-plus';
        this.addFlag = true;
        this.confimType = 'add';
        this.showAddEditModal = true;
      } else if (type == 2) {
        this.modalTitle = 'ویرایش اطلاعات شخصی';
        this.modalIcon = 'mdi-pencil';
        this.confimType = 'edit';
        this.addFlag = false;
        this.getUserPersonnelInfoFunction(id);
        this.showAddEditModal = true;
      }
    },
    cancelAddEditFunction: function () {
      this.userPersonnelInfo = new UserPersonnelInfo('', '', null, null);
      this.tempUserStartDate = '';
      this.showAddEditModal = false;
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addUserPersonnelInfoFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش اطلاعات شخصی';
        this.$refs.confirm.text = 'از ویرایش اطلاعات شخصی اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف اطلاعات شخصی';
        this.$refs.confirm.text = 'از حذف اطلاعات شخصی اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addUserPersonnelInfoFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editUserPersonnelInfoFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteUserPersonnelInfoFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.userPersonnelInfoId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
    userStartDateChange: function () {
      if (this.userPersonnelInfo.startDate) {
        this.tempUserStartDate = Vue.moment(this.userPersonnelInfo.startDate).format(
          'jYYYY-jMM-jDD',
        );
      }
    },
    backToUsers: function () {
      this.$router.push({ name: 'user' });
    },
  },
};
